export const getProductPluralForm = (count: number): string => {
  const lastDigit = count % 10;
  const lastTwoDigits = count % 100;

  if (lastTwoDigits >= 11 && lastTwoDigits <= 19) {
    return 'Продуктов';
  }

  if (lastDigit === 1) {
    return 'Продукт';
  } else if (lastDigit >= 2 && lastDigit <= 4) {
    return 'Продукта';
  } else {
    return 'Продуктов';
  }
};

export const getProductPluralFormEn = (count: number): string => {
  return count === 1 ? 'Product' : 'Products';
};

export const getProductPluralFormRo = (count: number): string => {
  const lastDigit = count % 10;
  const lastTwoDigits = count % 100;

  if (lastTwoDigits >= 11 && lastTwoDigits <= 19) {
    return 'Produse';
  }

  if (lastDigit === 1) {
    return 'Produs';
  } else if (lastDigit >= 2 && lastDigit <= 4) {
    return 'Produse';
  } else {
    return 'Produse';
  }
};
